import React, { useEffect, useState } from 'react';


interface Props {
    dataSet: any;
  }

interface RenderedTimeInterface {
  tens: string | number;
  ones: string | number;
}

class RenderedTime implements RenderedTimeInterface {
  tens: string | number = '';
  ones: string | number = '';
  constructor(tens: string | number = '', ones: string | number = '') {
    this.tens = tens;
    this.ones = ones
  }
}
interface StateTimeInterface {
  days: RenderedTime;
  hours: RenderedTime;
  minutes: RenderedTime;
  seconds: RenderedTime;
}

class StateTime implements StateTimeInterface {
  days: RenderedTime = new RenderedTime;
  hours: RenderedTime = new RenderedTime;
  minutes: RenderedTime = new RenderedTime;
  seconds: RenderedTime = new RenderedTime;

}

const CountdownTimer = ({dataSet}: Props): JSX.Element => {
  const timerData = JSON.parse(dataSet.timerSettings);
  const { year, month, day, hour, minute, second, title, text, textAlignment, btnText, btnLink, textPosition, afterTitle, textColourMob, hasImage, afterImage: {deskOne, tabOne, mobOne, deskTwo, tabTwo, mobTwo}  } = timerData
  const [limit, setLimit] = useState(0);
  const [renderDate, setRenderDate] = useState(new StateTime)

  const prependZero = (num:number): RenderedTime => {
    if(num < 10){
      return {tens: 0, ones: num}
    } 
    const fullSplit = num.toString().split('');
    return new RenderedTime(fullSplit[0],fullSplit[1]);
  
    
  }
  const renderDateInReadableFormat = (ms:number): StateTime => {
    const seconds = Math.floor((ms / 1000)) % 60
     
    const minutes = Math.floor(ms / (60 * 1000)) % 60
     
    const hours = Math.floor(ms / (60 * 60 * 1000)) % 24
     
    const days = Math.floor(ms / (24 * 60 * 60 * 1000 ));

    return {
      days: prependZero(days),
      hours: prependZero(hours),
      minutes: prependZero(minutes),
      seconds: prependZero(seconds)
    }
  }
  //Set the countdown end in milliseconds on render
  useEffect(() => {
    const limitInMilliseconds = new Date(`${month} ${day} ${year} ${hour}:${minute}:${second}`).getTime();
    setLimit(limitInMilliseconds);
  }, [dataSet])

  //Set timer to update every second.
  useEffect(() => {
    setInterval(function() {
      if(limit > 0){
        const presentToEnd = limit - Date.now();
        setRenderDate(renderDateInReadableFormat(presentToEnd))
      }
    }, 1000)

  }, [limit, renderDate])

  let timer: JSX.Element;
  let computedTitle: boolean

  const setHtml = (txt:string): any => {
    return {__html: txt}
  }

  const buildPictureEl = (): JSX.Element => {
    return (
      <div className="content-image-block-snippet half">
        <picture>
          <source
            media="(max-width: 415px)"
            data-lazy-load           
            data-srcset={`${mobOne} 1x, ${mobTwo} 2x`}
            srcSet={`${mobOne} 1x, ${mobTwo} 2x`}
          />
          <source
            media="(max-width: 680px)"
        
            data-lazy-load           
            data-srcset={`${tabOne} 1x, ${tabTwo} 2x`}
            srcSet={`${tabOne} 1x, ${tabTwo} 2x`}
          />
          <img
            data-lazy-load
            className="image_full"          
            data-src={`${deskOne}`}
            data-srcset={`${deskOne} 1x, ${deskTwo} 2x`}
            src={`${deskOne}`}
            srcSet={`${deskOne} 1x, ${deskTwo} 2x`}
            alt={afterTitle} />
        </picture>
      </div>
    )
  }

  if(limit >= Date.now()) {
    computedTitle = false
    timer = (
      <div className="timer-flex">
        <div className="timer-days">
          <div className="timer-flex">
            <span>{renderDate.days.tens}</span><span>{renderDate.days.ones}</span>
          </div>
          <p>Days</p>
        </div>
        <div className="colon">:</div>
        <div className="timer-hours">
          <div className="timer-flex">
            <span>{renderDate.hours.tens}</span><span>{renderDate.hours.ones}</span>
          </div><p>Hours</p>
        </div>
        <div className="colon">:</div>
        <div className="timer-minutes">
          <div className="timer-flex">
            <span>{renderDate.minutes.tens}</span><span>{renderDate.minutes.ones}</span>
          </div>
          <p>Minutes</p>
        </div>
        <div className="colon">:</div>
        <div className="timer-seconds">
          <div className="timer-flex">
            <span>{renderDate.seconds.tens}</span><span>{renderDate.seconds.ones}</span>
          </div>
          <p>Seconds</p>
        </div>
      </div>
    )
  } else {
    if(limit > 0) {
      computedTitle = true
      timer = <div className="cta-buttons" style={{ alignItems: textPosition }}><a href={btnLink} className={textColourMob === 'true' ? 'btn timer-btn white' : 'btn timer-btn'}>{btnText}</a></div>
    }
  }

  return (<div className="timer-wrapper">
    <div className={hasImage === 'true'  && limit < Date.now() ? 'content-image-block-snippet half flex center column' : 'flex center column'}>
      <p className="show-desktop heading-5 font-basic bold tag" style={{textAlign: textAlignment}}>{computedTitle ? afterTitle : title}</p>
      <p className={textColourMob === 'true' ? 'show-mobile heading-5 font-basic bold tag white': 'show-mobile heading-5 font-basic bold tag'} style={{textAlign: textAlignment}}>{computedTitle ? afterTitle : title}</p>
      <h2 dangerouslySetInnerHTML={setHtml(text)} className="show-desktop heading-1" style={{textAlign: textAlignment}}></h2>
      <h2 dangerouslySetInnerHTML={setHtml(text)} className={textColourMob === 'true' ? 'show-mobile heading-1 white': 'show-mobile heading-1'} style={{textAlign: textAlignment}}></h2>
      {timer}
    </div>
    {hasImage === 'true' && limit < Date.now() ? buildPictureEl() : null}
  </div>)
}

export default CountdownTimer